import React from 'react';
import styled from 'styled-components';

import { Flex } from 'src/packages/core';

require('react-datepicker/dist/react-datepicker.css');

export const DatePickerWrapper = styled((props) => <Flex {...props} />)`
  ${({ defaulttheme: { colors, typographyScale, mediaQueries }, themetype }) => `
    .react-datepicker-wrapper {
      width: inherit;
      height: fit-content;
    }
    
    .react-datepicker {
      background: ${colors.background.secondary.BG3};
      color: ${colors.text.primary};
      font-family: Inter-Regular;
      border: 0;
      .react-datepicker__triangle::after, .react-datepicker__triangle::before {
        border-bottom-color: ${colors.background.secondary.BG3};
      }
      .react-datepicker__time-container {
        border-left-color: ${colors.border.middle};
        background: transparent;
        & .react-datepicker__time {
          background-color: transparent !important;
        }
      }
      .react-datepicker__header {
        background: transparent;
        border-bottom-color: ${colors.border.middle};
      }
      .react-datepicker__current-month, 
      .react-datepicker__day-name, 
      .react-datepicker__day, 
      .react-datepicker-time__header {
        color: ${colors.text.primary};
      }
      .react-datepicker__day:hover, .react-datepicker__time-list-item:hover {
        background-color: ${colors.palette.primary} !important;
        color: ${themetype === 'light' ? colors.palette.white : colors.palette.black};
      }
      .react-datepicker__navigation-icon::before {
        border-color: ${colors.text.primary};
      }
      .react-datepicker__day--selected, 
      .react-datepicker__day--keyboard-selected, 
      .react-datepicker__time-list-item--selected {
        background-color: ${colors.palette.primary} !important;
        color: ${themetype === 'light' ? colors.palette.white : colors.palette.black} !important;
        font-weight: normal !important;
      }
    }

    .date-picker-input{
      input{;
        min-width: 230px;
        font-size:${typographyScale.desktop.p2.fontSize};
        line-height:${typographyScale.desktop.p2.lineHeight};
        font-family:${typographyScale.desktop.p2.fontFamily};
        font-weight:${typographyScale.desktop.p2.fontWeight};
        color: ${colors.text.primary};
        direction: ltr;
        &:placeholder {
          color:${colors.text.secondary};
          font-size: inherit;
        }
      }
      svg {
        height:16px;
        width:16px;
      }
    }
    ${mediaQueries.md} {
      .react-datepicker {
        display: flex;
        max-width: 100%;
        .react-datepicker__month-container{
          display: flex;
          flex-direction: column;
          flex: 1;
        }
        .react-datepicker__time-container{
          width: 85px;
        }
      }
    }
  `}
`;
